export default __webpack_public_path__ + "static/media/dolls_dark.85c0b42f.png";